<template>

  <div class="wrapper-outer">
    <div class="get-email">

    <b-form-group class="no-border" :feedback="error" :state="!error">
      <b-input-group>
        <b-form-input v-model="email" class="hero-input" type="text" placeholder="yourname@example.com"></b-form-input>
        <div class="input-group-append">
          <b-btn class="red" @click="onClickSignUp">Subscribe</b-btn>
        </div>
      </b-input-group>
    </b-form-group>

    </div>
  </div>

</template>

<style lang="scss" scoped>
@import '~scss/colors.scss';

.no-border {
  border: none;
}

.wrapper {
  display: block;
  width: 100%;
}

.get-email{
    max-width:450px;
    margin:0 auto;
}

.hero-input {
  height: 45px;
  border-radius: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.btn {
  height: 45px;
  border:$red 1px solid;
}

.red{
 background-color:$red;
}


@import url("https://fonts.googleapis.com/css?family=Roboto");
@import "~scss/social.scss";
</style>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      email: "",
      busy: false,
      error: ''
    };
  },
  methods: {
    ...mapActions(["emailSignUp"]),
    async onClickSignUp() {
      if (!this.email) return;
      // Do the request
      this.busy = true;
      let {success, message, email} = await this.emailSignUp(this.email);
      console.log('result:', success, message, email);
      this.busy = false;

      if (success) {
        this.error = 'Thank you! Please check your inbox.';
        this.email = '';
      } else if (message === 'Member Exists') {
        this.error = 'All good! You have already subscribed.';
      } else {
        // We got a list of errors for the email field. Shpw under the email.
        this.error = email ? email[0] : message || 'Sorry, an error occurred.';
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/homepage/shared/GetEmail.vue